export default "__VITE_ASSET__CbCMApOe__"